import { Theme, alpha } from "@mui/material/styles";


export const SectionStyle = ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "flex-start", // changed from "left" to valid CSS value
	paddingLeft: 0,
	paddingRight: 0,
	paddingTop: 2,
	paddingBottom: 2,
});



export const ContainmentFieldTitle = {
	fontWeight: "bold",
	color: "text.secondary",
	fontSize: "0.9rem",
}

export const ContainmentFieldValue = {
	whiteSpace: "pre-wrap",
	wordBreak: "break-word",
	fontSize: "0.9rem",
}

export const ComponentTitleStyle = {
	fontWeight: 600,
	fontSize: "1rem",
}


export const ElevatedPaperStyle = (theme: Theme) => ({
	p: { xs: 2, md: 4 },
	borderRadius: 2,
	position: "relative",
	overflow: "hidden",
	backdropFilter: "blur(8px)",
	boxShadow: `0 10px 40px ${alpha(theme.palette.common.black, 0.1)}`,
})


export const InputWrapperStyles = (theme: Theme) => ({
	"& .MuiInputBase-root": {
		borderRadius: 1,
		transition: "box-shadow 0.15s ease",
		"&:hover": {
			boxShadow: `0 1px 4px ${alpha(theme.palette.primary.main, 0.08)}`,
		},
		"&.Mui-focused": {
			boxShadow: `0 2px 6px ${alpha(theme.palette.primary.main, 0.12)}`,
		},
	},
})

export const FormLabelStyle = {
	fontWeight: 500,
	fontSize: "0.9rem",
	letterSpacing: "-0.01em",
	mb: 0.5,
}


